import { BASE_PATH } from '../../shared/types';

export function NotFound() {
  return (
    <main class="container">
      <h1>Page not found</h1>
      <p>Check the address, or open the link again from the message it came in.</p>
      <p><a href={`${BASE_PATH}/help`}>Get help using this website</a></p>
    </main>
  );
}
